import React from 'react';
import Tasks from './Tasks';

// Stranica identična admin "Zadaci" stranici, ali koristi physiotherapist endpoint
// GET /api/Task/physiotherapist-tasks-by-date
const PhysiotherapistTasksPage = () => (
  <Tasks
    endpoint="/api/Task/physiotherapist-tasks-by-date"
    showAddTask={false}
    selectable={false}
    collapseCategoriesByDefault={false}
  />
);

export default PhysiotherapistTasksPage;
